import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map, noop } from 'lodash';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import CompaniesTableHeader from '../companies_table_header';
import CompanyRow from '../company_row';

import { getDuplicateCompanies } from '../../store/selectors/duplicates';
import { getSelectedCompanyIds } from '../../store/selectors/select_list';

export function DuplicatesTable({ duplicates, selectedCompanyIds }) {
  const isSelected = company => selectedCompanyIds.includes(company.id);

  const renderCompanies = () => (
    map(duplicates, company => (
      <CompanyRow
        canPreview={() => false}
        company={company}
        key={company.id}
        selected={isSelected(company)}
        updatePreviewOverlay={noop}
      />
    ))
  );

  return (
    <SelectableRecordTable
      columnHeaders={<CompaniesTableHeader allowSort={false} />}
      hasSelectAll={false}
    >
      {renderCompanies()}
    </SelectableRecordTable>
  );
}

DuplicatesTable.propTypes = {
  duplicates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  selectedCompanyIds: PropTypes.arrayOf(PropTypes.number).isRequired
};

const mapStateToProps = state => ({
  duplicates: getDuplicateCompanies(state),
  selectedCompanyIds: getSelectedCompanyIds(state)
});

export default connect(mapStateToProps)(DuplicatesTable);
